import {
  MUTATE,
  MUTATE_MULTIPLE,
  MUTATE_OBJECT_KEY,
  MUTATE_REMOVE_OBJECT_KEY,
  APPEND,
} from '@/store/modules/mutation_types';
import {
  mutate,
  mutateMultiple,
  mutateObjectKey,
  mutateRemoveObjectKey,
  append,
} from '@/store/modules/mutations';

export default {
  [MUTATE]: mutate,
  [MUTATE_MULTIPLE]: mutateMultiple,
  [MUTATE_OBJECT_KEY]: mutateObjectKey,
  [MUTATE_REMOVE_OBJECT_KEY]: mutateRemoveObjectKey,
  [APPEND]: append,
};
